// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
}

.dashboard-page {
  padding: 2px 0 8px;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h1 {
  margin: 0;
  color: #172b46;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
}

.page-header p {
  margin: 6px 0 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 19px;
}

.dashboard-skeleton {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.skeleton-card {
  display: flex;
  gap: 14px;
  min-height: 128px;
  padding: 17px;
  box-sizing: border-box;
  border: 1px solid #e2e9f2;
  border-inline-start: 4px solid #e2e9f2;
  border-radius: 10px;
  background: #fff;
}

.skeleton-card > div {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 9px;
}

.skeleton {
  display: block;
  border-radius: 5px;
  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.35s ease infinite;
}

.skeleton-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
}

.skeleton-label {
  width: 70%;
  height: 12px;
}

.skeleton-value {
  width: 52%;
  height: 24px;
}

.skeleton-link {
  width: 42%;
  height: 11px;
  margin-top: auto;
}

.skeleton-chart {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px 16px;
  min-height: 300px;
  padding: 18px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
  box-sizing: border-box;
}

.skeleton-chart-title {
  width: 130px;
  height: 14px;
}

.skeleton-chart-copy {
  width: 180px;
  height: 10px;
  margin-top: 7px;
}

.skeleton-select {
  width: 112px;
  height: 35px;
}

.skeleton-graph {
  grid-column: 1/-1;
  height: 220px;
  margin-top: 10px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
  min-width: 0;
}

.metric-card {
  display: flex;
  min-height: 128px;
  border: 1px solid #e2e9f2;
  border-inline-start: 4px solid var(--primary-color);
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.metric-icon {
  display: grid;
  place-items: center;
  align-self: flex-start;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  margin: 17px 12px 0 17px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--primary-color) 8%, white);
}

.metric-icon .material-symbols-outlined {
  font-size: 23px;
}

.metric-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding: 17px 18px 17px 0;
}

.metric-label {
  color: #7d8a9d;
  font-size: 11px;
  line-height: 17px;
}

.metric-body strong {
  margin: 4px 0 10px;
  color: #253750;
  font-size: 23px;
  font-weight: 600;
  line-height: 28px;
}

.text-button {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin: auto -7px -4px;
  padding: 4px 7px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--primary-color);
  font: inherit;
  font-size: 11px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.text-button .material-symbols-outlined {
  font-size: 15px;
}

.text-button:hover {
  background: color-mix(in srgb, var(--primary-color) 9%, white);
  text-decoration: none;
}

.metric-card.earnings {
  border-inline-start-color: var(--primary-color);
}

.metric-card.earnings .metric-icon {
  background: color-mix(in srgb, var(--primary-color) 8%, white);
  color: var(--primary-color);
}

.metric-card.earnings .metric-body strong {
  white-space: nowrap;
  font-size: 22px;
  letter-spacing: -0.2px;
}

.metric-card.vat {
  border-inline-start-color: #d97706;
}

.metric-card.vat .metric-icon {
  background: #fff4e5;
  color: #c56b05;
}

.metric-card.vat .text-button {
  color: #c56b05;
}

.metric-card.vat .text-button:hover {
  background: #fff4e5;
}

.metric-card.products {
  border-inline-start-color: #36866a;
}

.metric-card.products .metric-icon {
  background: #eef7f2;
  color: #36866a;
}

.metric-card.products .text-button {
  color: #36866a;
}

.metric-card.products .text-button:hover {
  background: #eef7f2;
}

.metric-card.featured {
  border-inline-start-color: #b57a18;
}

.metric-card.featured .metric-icon {
  background: #fff7e6;
  color: #a96e0d;
}

.metric-card.featured .text-button {
  color: #a96e0d;
}

.metric-card.featured .text-button:hover {
  background: #fff7e6;
}

.chart-card {
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.chart-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border-bottom: 1px solid #edf1f6;
}

.chart-heading h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
}

.chart-heading p {
  margin: 3px 0 0;
  color: #7d8a9d;
  font-size: 11px;
}

.chart-heading mat-form-field {
  width: 112px;
  font-size: 11px;
  --mat-form-field-container-height: 35px;
  --mat-form-field-container-vertical-padding: 7px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color);
}

.graph-container {
  padding: 18px;
}

.line-chart {
  width: 100% !important;
}

.chart-skeleton {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: end;
  gap: 14px;
  height: 240px;
  padding: 18px;
  box-sizing: border-box;
  border-radius: 8px;
  background: repeating-linear-gradient(to bottom, transparent 0, transparent 47px, #edf1f6 48px);
}

.chart-skeleton span {
  display: block;
  border-radius: 5px 5px 0 0;
  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);
  background-size: 400% 100%;
  animation: chart-skeleton-loading 1.35s ease infinite;
}

.chart-skeleton span:nth-child(1) {
  height: 35%;
}

.chart-skeleton span:nth-child(2) {
  height: 62%;
}

.chart-skeleton span:nth-child(3) {
  height: 48%;
}

.chart-skeleton span:nth-child(4) {
  height: 76%;
}

.chart-skeleton span:nth-child(5) {
  height: 42%;
}

@keyframes chart-skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
@media (max-width: 1050px) {
  .metric-grid,
  .dashboard-skeleton {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .skeleton-chart {
    grid-column: 1/-1;
    min-width: 0;
  }
}
@media (max-width: 650px) {
  .metric-grid,
  .dashboard-skeleton {
    grid-template-columns: 1fr;
  }
  .chart-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .page-header h1 {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/marketplace-dashboard/marketplace-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,+CAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AACJ;;AAEA;EACI,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,iBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI;IACI,2BAAA;EACN;EAEE;IACI,wBAAA;EAAN;AACF;AAGA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;AADJ;;AAIA;EACI,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,mDAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,8DAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,aAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,yDAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,8DAAA;EACA,qBAAA;AADJ;;AAIA;EACI,+CAAA;AADJ;;AAIA;EACI,8DAAA;EACA,2BAAA;AADJ;;AAIA;EACI,mBAAA;EACA,eAAA;EACA,sBAAA;AADJ;;AAIA;EACI,kCAAA;AADJ;;AAIA;EACI,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,kCAAA;AADJ;;AAIA;EACI,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,kCAAA;AADJ;;AAIA;EACI,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AADJ;;AAIA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AADJ;;AAIA;EACI,YAAA;EACA,eAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,mEAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,sBAAA;AADJ;;AAIA;EACI,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,+FAAA;AADJ;;AAIA;EACI,cAAA;EACA,0BAAA;EACA,yEAAA;EACA,0BAAA;EACA,qDAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI;IACI,2BAAA;EADN;EAIE;IACI,wBAAA;EAFN;AACF;AAKA;EAEI;;IAEI,gDAAA;EAJN;EAOE;IACI,iBAAA;IACA,YAAA;EALN;AACF;AAQA;EAEI;;IAEI,0BAAA;EAPN;EAUE;IACI,uBAAA;IACA,sBAAA;EARN;EAWE;IACI,eAAA;EATN;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px;\n}\n\n.dashboard-page {\n    padding: 2px 0 8px;\n}\n\n.page-header {\n    margin-bottom: 24px;\n}\n\n.page-header h1 {\n    margin: 0;\n    color: #172b46;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 30px;\n    text-transform: capitalize;\n}\n\n.page-header p {\n    margin: 6px 0 0;\n    color: #7d8a9d;\n    font-size: 12px;\n    line-height: 19px;\n}\n\n.dashboard-skeleton {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n}\n\n.skeleton-card {\n    display: flex;\n    gap: 14px;\n    min-height: 128px;\n    padding: 17px;\n    box-sizing: border-box;\n    border: 1px solid #e2e9f2;\n    border-inline-start: 4px solid #e2e9f2;\n    border-radius: 10px;\n    background: #fff;\n}\n\n.skeleton-card>div {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 9px;\n}\n\n.skeleton {\n    display: block;\n    border-radius: 5px;\n    background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);\n    background-size: 400% 100%;\n    animation: skeleton-loading 1.35s ease infinite;\n}\n\n.skeleton-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n}\n\n.skeleton-label {\n    width: 70%;\n    height: 12px;\n}\n\n.skeleton-value {\n    width: 52%;\n    height: 24px;\n}\n\n.skeleton-link {\n    width: 42%;\n    height: 11px;\n    margin-top: auto;\n}\n\n.skeleton-chart {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 8px 16px;\n    min-height: 300px;\n    padding: 18px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff;\n    box-sizing: border-box;\n}\n\n.skeleton-chart-title {\n    width: 130px;\n    height: 14px;\n}\n\n.skeleton-chart-copy {\n    width: 180px;\n    height: 10px;\n    margin-top: 7px;\n}\n\n.skeleton-select {\n    width: 112px;\n    height: 35px;\n}\n\n.skeleton-graph {\n    grid-column: 1 / -1;\n    height: 220px;\n    margin-top: 10px;\n}\n\n@keyframes skeleton-loading {\n    0% {\n        background-position: 100% 0;\n    }\n\n    100% {\n        background-position: 0 0;\n    }\n}\n\n.metric-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n    margin-bottom: 18px;\n    min-width: 0;\n}\n\n.metric-card {\n    display: flex;\n    min-height: 128px;\n    border: 1px solid #e2e9f2;\n    border-inline-start: 4px solid var(--primary-color);\n    border-radius: 10px;\n    background: #fff;\n    overflow: hidden;\n}\n\n.metric-icon {\n    display: grid;\n    place-items: center;\n    align-self: flex-start;\n    flex: 0 0 38px;\n    width: 38px;\n    height: 38px;\n    margin: 17px 12px 0 17px;\n    border-radius: 50%;\n    background: color-mix(in srgb, var(--primary-color) 8%, white);\n}\n\n.metric-icon .material-symbols-outlined {\n    font-size: 23px;\n}\n\n.metric-body {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 17px 18px 17px 0;\n}\n\n.metric-label {\n    color: #7d8a9d;\n    font-size: 11px;\n    line-height: 17px;\n}\n\n.metric-body strong {\n    margin: 4px 0 10px;\n    color: #253750;\n    font-size: 23px;\n    font-weight: 600;\n    line-height: 28px;\n}\n\n.text-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    margin: auto -7px -4px;\n    padding: 4px 7px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: var(--primary-color);\n    font: inherit;\n    font-size: 11px;\n    cursor: pointer;\n    transition: background-color .15s ease, color .15s ease;\n}\n\n.text-button .material-symbols-outlined {\n    font-size: 15px;\n}\n\n.text-button:hover {\n    background: color-mix(in srgb, var(--primary-color) 9%, white);\n    text-decoration: none;\n}\n\n.metric-card.earnings {\n    border-inline-start-color: var(--primary-color);\n}\n\n.metric-card.earnings .metric-icon {\n    background: color-mix(in srgb, var(--primary-color) 8%, white);\n    color: var(--primary-color);\n}\n\n.metric-card.earnings .metric-body strong {\n    white-space: nowrap;\n    font-size: 22px;\n    letter-spacing: -.2px;\n}\n\n.metric-card.vat {\n    border-inline-start-color: #d97706;\n}\n\n.metric-card.vat .metric-icon {\n    background: #fff4e5;\n    color: #c56b05;\n}\n\n.metric-card.vat .text-button {\n    color: #c56b05;\n}\n\n.metric-card.vat .text-button:hover {\n    background: #fff4e5;\n}\n\n.metric-card.products {\n    border-inline-start-color: #36866a;\n}\n\n.metric-card.products .metric-icon {\n    background: #eef7f2;\n    color: #36866a;\n}\n\n.metric-card.products .text-button {\n    color: #36866a;\n}\n\n.metric-card.products .text-button:hover {\n    background: #eef7f2;\n}\n\n.metric-card.featured {\n    border-inline-start-color: #b57a18;\n}\n\n.metric-card.featured .metric-icon {\n    background: #fff7e6;\n    color: #a96e0d;\n}\n\n.metric-card.featured .text-button {\n    color: #a96e0d;\n}\n\n.metric-card.featured .text-button:hover {\n    background: #fff7e6;\n}\n\n.chart-card {\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff;\n    overflow: hidden;\n}\n\n.chart-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 16px 18px;\n    border-bottom: 1px solid #edf1f6;\n}\n\n.chart-heading h2 {\n    margin: 0;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 20px;\n}\n\n.chart-heading p {\n    margin: 3px 0 0;\n    color: #7d8a9d;\n    font-size: 11px;\n}\n\n.chart-heading mat-form-field {\n    width: 112px;\n    font-size: 11px;\n    --mat-form-field-container-height: 35px;\n    --mat-form-field-container-vertical-padding: 7px;\n    --mdc-outlined-text-field-outline-color: #dce5ef;\n    --mdc-outlined-text-field-focus-outline-color: var(--primary-color);\n}\n\n.graph-container {\n    padding: 18px;\n}\n\n.line-chart {\n    width: 100% !important;\n}\n\n.chart-skeleton {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    align-items: end;\n    gap: 14px;\n    height: 240px;\n    padding: 18px;\n    box-sizing: border-box;\n    border-radius: 8px;\n    background: repeating-linear-gradient(to bottom, transparent 0, transparent 47px, #edf1f6 48px);\n}\n\n.chart-skeleton span {\n    display: block;\n    border-radius: 5px 5px 0 0;\n    background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);\n    background-size: 400% 100%;\n    animation: chart-skeleton-loading 1.35s ease infinite;\n}\n\n.chart-skeleton span:nth-child(1) {\n    height: 35%;\n}\n\n.chart-skeleton span:nth-child(2) {\n    height: 62%;\n}\n\n.chart-skeleton span:nth-child(3) {\n    height: 48%;\n}\n\n.chart-skeleton span:nth-child(4) {\n    height: 76%;\n}\n\n.chart-skeleton span:nth-child(5) {\n    height: 42%;\n}\n\n@keyframes chart-skeleton-loading {\n    0% {\n        background-position: 100% 0;\n    }\n\n    100% {\n        background-position: 0 0;\n    }\n}\n\n@media (max-width: 1050px) {\n\n    .metric-grid,\n    .dashboard-skeleton {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .skeleton-chart {\n        grid-column: 1 / -1;\n        min-width: 0;\n    }\n}\n\n@media (max-width: 650px) {\n\n    .metric-grid,\n    .dashboard-skeleton {\n        grid-template-columns: 1fr;\n    }\n\n    .chart-heading {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .page-header h1 {\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
